import { connect } from 'react-redux';
import { getIsSectionFolded } from '../../redux/selectors';
import { updateNetworkBarSection } from '../../redux/actions';
const mapStateToProps = (state, { sectionType })=>({
        isFolded: getIsSectionFolded(state, sectionType)
    });
const mapDispatchToProps = {
    onFoldToggle: updateNetworkBarSection
};
export default connect(mapStateToProps, mapDispatchToProps);

//# sourceMappingURL=FoldableGroupList.container.js.map